import type { Budget, BudgetServiceLine } from "../types";
import {
  getBudgetLineLabel,
  getBudgetLineOptionalSubServiceIds,
  parseBudgetPrice,
} from "./budgetUtils";

export interface BudgetAppointmentPrefill {
  clientId: number;
  serviceId: number;
  clientCarId?: number;
  price: string;
  subServiceIds: number[];
  lockPrice: boolean;
  budgetId: number;
}

export function buildAppointmentPrefillFromBudgetLine(
  budget: Budget,
  line: BudgetServiceLine
): BudgetAppointmentPrefill {
  const optionalSubServiceIds = getBudgetLineOptionalSubServiceIds(line);

  return {
    clientId: budget.clientId,
    serviceId: line.serviceId,
    clientCarId: budget.clientCarId ?? undefined,
    price: parseBudgetPrice(line.price).toFixed(2),
    subServiceIds: optionalSubServiceIds,
    lockPrice: true,
    budgetId: budget.id,
  };
}

export function getBudgetServicePickerLabel(line: BudgetServiceLine): string {
  const name = getBudgetLineLabel(line);
  const price = parseBudgetPrice(line.price).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
  return `${name} — ${price}`;
}
